import { useEffect, useState } from "react"
import { TalentService } from "../../../core/services/TalentService"
import { Singleton } from "../../../core/services/Singleton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { ProofAccounts } from "./ProofAccounts";
import { ListMenu } from "../../theme/Component/ListMenu";
import { InputDate } from "../../theme/Input/InputDate";
import { SelectTypeTest } from "../../bpm/config/Componentes/SelectTypeTest";
import { DropDown } from "../../theme/Component/DropDown";
import useModal, { MODAL_md } from "../../theme/Component/hooks/useModal";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { EditorActaComite } from "../../custom/forpo/components/ActaComite/EditorActaComite";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ProofAccounts, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";

export const Proof = () => {

    const services = new TalentService();
    const _proofAccounts = useDataBean(_ProofAccounts);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalProAcc, setModalProAcc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalActa = useModal("Actas de Crédito",MODAL_md);

    useEffect(() => {
        getLista()
    }, [])

    const idBean = 'IDProof';

    const head = [
        { title: 'ID', property: idBean, mask: MASK_NUMBER },
        { title: 'Encuesta', property: 'Name' },
        { title: 'Acta', property: 'ComiteNumber' },
        { title: 'Observación', property: 'Description' },
        { title: 'Desde', property: 'FromDate', mask: MASK_DATE },
        { title: 'Ultima Actualización', property: 'LastUpdate', mask: MASK_DATE },
        { title: 'Funcionario', property: 'EmployeeName'},
        
        { title: 'Estado', property: 'StateName' },
    ]

    const setRowBean = (bean: any) => {
        setBean(bean);
    }

    const getLista = () => {
        const x = {
            "State": 1
        }
        single.spinner(true);
        services.getProofCatalogPorPropiedadesRender(null, x).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let x = resp.DataBeanProperties.ObjectValue;
                    // x.forEach((test: any) => {
                    //     test.DataBeanProperties.TypeName = renderName(test.DataBeanProperties.TestType)
                    // });
                    setLista(x)
                }
                single.spinner(false)
            }
        )
    }

    const deleteItem = () => {
        bean.State = 2;
        //console.log(bean);
        updateItem();
        setModalConfirm({ ...modalConfirm, 'view': false });
    }

    const updateItem = () => {
        // console.log(bean)
        if(bean.IDActaComite>0)
        {
            _proofAccounts.instance.createProoByActa(bean.IDTest,_single.getAccountID(),bean.IDActaComite).then(
                (resp:any)=>{
                    toast.success("Se han creado las encuestas");
                     setModal({ ...modal, "view": false });
                }
            )
        }else{

            setModal({ ...modal, "view": false })
            single.spinner(true);
            services.updateProof(bean).subscribe(
                (resp: any) => {
                    if (resp.DataBeanProperties.ObjectValue) {
                        getLista();
                    }
                    single.spinner(false)
                    if (bean.IDTest) {
                        single.update(bean);
                    } else {
                        single.create(bean)
                    }
                }
            )
        }
    }
    const createByActa=()=>{

    }

    const agregarItem = () => {
        let b = {
            IDEmployee: single.getAccountID(),
            State: 1,
            IDTest: undefined,
            JSONTest: '',
            From: single.getCurrenDate(),
            Upto: single.getCurrenDate(),
        }
        setBean(b);
        setModal({ ...modal, 'view': true });

    }
    const lansarEncuestas=()=>{
        _proofAccounts.instance.sendTestByIDProof(bean.IDProof,_single.getAccountID()).then(
            (resp:any)=>{
                toast.success("Se ha lanzado las encuestas");
                modalActa.close();
                getLista();
            }
        )

    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
            { titulo: 'Usuarios en la Prueba', icono: 'ri-user-line', visible: true, evento: () => { setModalProAcc({ ...modalProAcc, "name": `Usuarios de la prueba `, "view": true }) } },
            { titulo: 'Enviar Solicitudes', icono: 'ri-mail-send-line', visible: bean.State === 1, evento: () => { modalActa.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const actionsDropDown = [
        { id: 1, name: 'Lanzar Encuesta Acta de Crédito', permiso: null, activo: true },
        // { id: 2, name: 'Ver Documentos', permiso: null, activo: false },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={eventosButton}></DropDown>
                </div>
            </div>
        )
    }

    const eventosButton=(e)=>{

        if(e.id == 1)
        {

        }

    }

    return (
        <BasicPage titulo="Encuestas">
            <div className="row">
                <div className="col-12">
                    <BasicTable  body={lista} head={head} rowSet={setRowBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
                </div>
            </div>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                    <div className="row">
                        <div className="col-6">
                            <InputDate label="Fecha desde:" name="Fecha desde:" value={bean.FromDate} setDate={(e: any) => { setBean({ ...bean, "FromDate": e }) }} />
                        </div>                       
                        <div className="col-12">
                            <SelectTypeTest idSelector={bean.IDTest} onChange={(e: any) => { setBean({ ...bean, "IDTest": e }) }}></SelectTypeTest>
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Cargar desde acta de credito" estado={bean.IDActaComite>0} eventChange={(e)=>{setBean({...bean,"Acta":e})}}/>
                        </div>
                        <div className="col-md-6">
                            {bean.Acta &&
                            <EditorActaComite label="Acta Comite" onChange={(e)=>{setBean({...bean,"IDActaComite":e?.IDActaComite})}}/>
                            }
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={(e)=>{setBean({...bean,"Description":e.target.value})}}></textarea>
                        </div>
                        <div className="col-md-6">
                            <label>Estado</label>
                            <select name="estado" className="form-select" value={bean.State} onChange={(e)=>{setBean({...bean,"State":parseInt(e.target.value)})}}>
                                <option value={1}>ACTIVO</option>
                                <option value={2}>ELIMINADO</option>
                                <option value={3}>TERMINADO</option>
                            </select>
                        </div>
                    </div>
                </Modal>
            }
            {modalProAcc.view &&
                <Modal modal={modalProAcc} updateModal={setModalProAcc} eventModal={""}>
                    <ProofAccounts idProof={bean.IDProof} />
                </Modal>
            }
            {modalConfirm.view &&
                <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={deleteItem}>
                    {bean.Name}
                </ModalConfirm>
            }
            {/* <Modal modal={modalActa.modal} updateModal={modalActa.setModal}>
                <div className="row">
                    <div className="col-md-6">

                    </div>
                </div>
            </Modal> */}
            <ModalConfirm modal={modalActa.modal} updateModal={modalActa.setModal} eventModal={lansarEncuestas}>
                    {bean.Name}
                </ModalConfirm>
        </BasicPage>
    )
}